export const urls = {
  ratesSummary: () => "/api/client/v1/shipping/rates-summary/",
};

export const keys = {
  all: () => ["shipping-all"],
  rates: () => [...keys.all(), "rates"],
  rateSummaries: () => [...keys.rates(), "summary"],
  rateSummary: () => [...keys.rateSummaries(), {}],
};
